<template>
<v-expansion-panels>
    <v-expansion-panel>
        <v-expansion-panel-header>
            <div class="detail font-weight-bold pa-0 ma-0">Address</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row no-gutters align="center" class="pt-2 im-search">
                <v-col cols="12" md="6">
                    <v-row no-gutters align="center">
                        <v-col cols="12" class="px-2">
                            <v-text-field v-model="item.address.city" class="ma-0 pa-0" label="City" />
                        </v-col>
                        <v-col cols="9" class="px-2">
                            <v-text-field v-model="item.address.region" class="ma-0 pa-0" label="Region" />
                        </v-col>
                        <v-col cols="3" class="px-2">
                            <v-select class="ma-0 pa-0" v-model="item.address.country" :items="countries" clearable label="Country" required :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row no-gutters align="center">
                        <v-col cols="12" class="px-2">
                            <v-text-field v-model="item.address.street" class="ma-0 pa-0" label="Street" hint="street name" />
                        </v-col>
                        <v-col cols="4" class="px-2">
                            <v-text-field v-model="item.address.number" class="ma-0 pa-0" label="Number" />
                        </v-col>
                        <v-col cols="4" class="px-2">
                            <v-text-field v-model="item.address.building" class="ma-0 pa-0" label="Building" hint="eg: ap., nr." />
                        </v-col>
                        <v-col cols="4" class="px-2">
                            <v-text-field v-model="item.address.postal_code" class="ma-0 pa-0" label="Postal Code" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },

    components: {},
    data() {
        return {
            //props
            birthdate: null,
            service: {},
            user: this.$clone(defaults.user_item),
            valid: true,
            menu: false,

            rules: {
                name: [v => !!v || "User first name is required"],
                email: [
                    v => !!v || "E-mail is required",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
                ],
            },
            title_items: [{
                    text: "Ms.",
                    value: "mr"
                },
                {
                    text: "Mrs.",
                    value: "mrs"
                },
                {
                    text: "Doctor",
                    value: "dr"
                }
            ],
            gender_items: [{
                    text: "Male",
                    value: "male"
                },
                {
                    text: "Female",
                    value: "female"
                }
            ],
            timezone: [
                "Europe/Amsterdam",
                "Europe/Athens",
                "Europe/Belgrade",
                "Europe/Berlin",
                "Europe/Bratislava",
                "Europe/Bucharest",
                "Europe/Budapest",
                "Europe/Chisinau",
                "Europe/Helsinki"
            ],
            countries: ["RO", "BG", "MD"],
        };
    },

    computed: {
        comp_birthdate: {
            get: function () {
                return this.formatDate(this.birthdate);
            },
            set: function (val) {
                return (this.birthdate = val);
            }
        },
    },

    watch: {
        menu(val) {
            val &&
                this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
        },

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("DD MMM YY");
        },

    }
};
</script>
